var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(-325 -291)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(325 291)",
    fill: "#39be9d",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-2",
    "data-name": "email",
    d: "M1.442,59.882h12.5a1.443,1.443,0,0,1,1.442,1.442v8.651a1.443,1.443,0,0,1-1.442,1.442H1.442A1.443,1.443,0,0,1,0,69.975V61.324A1.443,1.443,0,0,1,1.442,59.882Zm0,.961a.478.478,0,0,0-.184.037L7.69,66.455l6.432-5.575a.478.478,0,0,0-.184-.037Zm0,9.613h12.5a.481.481,0,0,0,.481-.481V61.9L8,67.455a.481.481,0,0,1-.63,0L.961,61.9v8.079A.481.481,0,0,0,1.442,70.456Z",
    transform: "translate(332 240.117)",
    fill: "#39be9d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3b8ca14a2c57f634709a11b6bf50d489.svg";
export { ForwardRef as ReactComponent };